declare var jQuery: any;
declare var $: any;

// Imports Angular
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, Compiler } from '@angular/core';
import { Http, HttpModule } from '@angular/http';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule, NoopAnimationsModule } from '@angular/platform-browser/animations';

// External Modules
import { FlexLayoutModule } from '@angular/flex-layout';
import { MaterialModule } from './configuracion/material.module';
import { SessionStorageService } from 'ngx-webstorage';
import { Ng2Webstorage } from 'ngx-webstorage';
import { DateValueAccessorModule } from 'angular-date-value-accessor';
import { CookieService } from 'angular2-cookie/services/cookies.service';
import { Logger } from 'angular2-logger/core';

/*translation */
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

// Components view
import { AppComponent } from './app.component';
import { PieComponent } from './components/pie/pie.component';
import { CabeceraFormularioComponent } from './components/formulario-experto/cabecera-formulario/cabecera-formulario.component';
import { ContenedorFormularioComponent } from './components/formulario-experto/contenedor-formulario/contenedor-formulario.component';
import { ContenedorFormularioComponent as ContenedorFormularioNoExpertoComponent } from './components/formulario-no-experto/contenedor-formulario/contenedor-formulario.component';
import { FormularioComponent } from './components/formulario-experto/formulario/formulario.component';
import { DFirmaComponente } from '@dian-cmp/firma';
import { DEnvioLogComponente } from '@dian-cmp/envio-log';
import { DSpeedDialComponente } from '@dian-cmp/speed-dial';
import { DatepickerModule } from '@dian-cmp/datepicker';
import { DPreguntasComponente } from '@dian-cmp/preguntas';
import { DNotificacionesComponente } from '@dian-cmp/notificaciones';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
//import { DReciboPagoModule } from '@dian-cmp/recibo-pago';
import { DReciboPagoExteriorModule } from '@dian-cmp/recibo-pago490-exterior';
import { DSoloNumeros } from './directives/dsolo-numeros';

// Libs framework
import { DLogger, DMessageObsService } from '@dian/core';
import { DLoggerAngular } from '@dian/core';
import { DContextoMuiscaServicio } from '@dian/core';
import { DSessionStorage } from '@dian/core';
import { DContextoMuiscaDesaServicio } from '@dian/core';
import { DFormularioServicio } from '@dian/api-formulario';
import {
  DInterfaceConfiguracionFormulario,
  DOperacionesMatematicasServicio,
  DValidacionesFormularioServicio,
  DAyudasFormularioServicio,
  DRenderizarPorParametrosDirectiva,
  DMostrarAyudaDirectiva,
  FormateoValorPipe,
  FormatoMonedaDirectiva,
  DMostrarAyudaBaseComponent
} from '@dian-cmp/formulario';

// Conf
import {
  loggerFactory,
  contextoMuiscaFactory,
  formularioFactory,
  validacionesFormularioFactory,
  sessionStorageFactory,
  ayudasFormularioFactory,
  HttpLoaderTranslatorFactory
} from './configuracion/app.factories';
import { DFormularioConfiguracion } from './configuracion/dformulario-configuracion';
import { DAyudasFormulario } from './configuracion/dayudas-formulario';
import { MissingTranslationHandlerDIAN } from './configuracion/missing-translation-handler-dian';
import { AppRoutingModule } from './app-routing.module';

//import { DialogoDeclaSugeridaComponent } from './components/declaracion-sugerida/dialogo-decla-sugerida/dialogo-decla-sugerida.component';
//import { DialogoFacturaRentaComponent } from  './components/factura-renta/dialogo-factura-renta/dialogo-factura-renta.component';
//import { DialogoValoresFacturaRentaComponent } from  './components/factura-renta/dialogo-valores-factura-renta/dialogo-val-factura-renta.component';
//import { DialogoValoresDeclaracionSugeridaComponent } from './components/declaracion-sugerida/dialogo-valores-declaracion-sugerida/dialogo-valores-declaracion-sugerida.component';
//import { DialogoConsultaFacturaRentaComponent } from  './components/factura-renta/dialogo-cons-factura-renta/dialogo-factura-renta.component';
//import { DialogoConsultaDeclaracionSugeridaComponent } from './components/declaracion-sugerida/dialogo-cons-decla-sugerida/dialogo-cons-decla-sugerida.component';
//import { DialogoFacturaEjecutoriaComponent } from './components/factura-renta/dialogo-factura-ejecutoria/dialogo-factura-ejecutoria.component';
import { LoadingComponent } from './components/loading/loading.component';
import { TabComponent, } from './components/tab/tab.component';
import { TitleModalComponent } from './components/title-modal/title-modal.component';
import { StepperComponent } from './components/stepper/stepper.component';
import { GeneralDialogComponent } from './components/dialogos/general/general-dialog.component';
import { TooltipDirective } from './directives/tooltip.directive';
import { NotificationsService } from './services/notifications.service';
import { MessageObservableService } from './services/message-observable.service';
import { ItemMenuComponent } from './components/item-menu/item-menu.component';
import { DReciboPagoModule } from './components/recibo-pago';
import { SugeridaComponent } from './components/dialogos/sugerida/sugerida.component';
import { FormularioNoExpertoComponent } from './components/formulario-no-experto/formulario/formulario-no-experto.component';
import { RentaLaboralComponent } from './components/formulario-no-experto/secciones/renta-laboral/renta-laboral.component';
import { DatosDeclaranteComponent } from './components/formulario-no-experto/secciones/datos-declarante/datos-declarante.component';
import { PatrimonioComponent } from './components/formulario-no-experto/secciones/patrimonio/patrimonio.component';
import { RentaCapitalComponent } from './components/formulario-no-experto/secciones/renta-capital/renta-capital.component';
import { RentaDividendosComponent } from './components/formulario-no-experto/secciones/renta-dividendos/renta-dividendos.component';
import { RentaPensionesComponent } from './components/formulario-no-experto/secciones/renta-pensiones/renta-pensiones.component';
import { GananciasOcasionalesComponent } from './components/formulario-no-experto/secciones/ganancias-ocasionales/ganancias-ocasionales.component';
import { DescuentosComponent } from './components/formulario-no-experto/secciones/descuentos/descuentos.component';
import { IndicatorComponent } from './components/indicator/indicator.component';
import { HeaderCardNoExpertosComponent } from './components/header-card-no-expertos/header-card-no-expertos.component';
import { PatrimonioMueblesModalComponent } from './components/formulario-no-experto/secciones/modales/patrimonio/patrimonio-muebles-modal/patrimonio-muebles-modal.component';
import { PatrimonioInmueblesModalComponent } from './components/formulario-no-experto/secciones/modales/patrimonio/patrimonio-inmuebles-modal/patrimonio-inmuebles-modal.component';
import { PatrimonioAccionesModalComponent } from './components/formulario-no-experto/secciones/modales/patrimonio/patrimonio-acciones-modal/patrimonio-acciones-modal.component';
import { PatrimonioDisponibleModalComponent } from './components/formulario-no-experto/secciones/modales/patrimonio/patrimonio-disponible-modal/patrimonio-disponible-modal.component';
import { PatrimonioInventarioModalComponent } from './components/formulario-no-experto/secciones/modales/patrimonio/patrimonio-inventario-modal/patrimonio-inventario-modal.component';
import { PatrimonioActivosExtranjeraModalComponent } from './components/formulario-no-experto/secciones/modales/patrimonio/patrimonio-activos-extranjera-modal/patrimonio-activos-extranjera-modal.component';
import { PatrimonioDeudaNacionalModalComponent } from './components/formulario-no-experto/secciones/modales/patrimonio/patrimonio-deuda-nacional-modal/patrimonio-deuda-nacional-modal.component';
import { PatrimonioDeudasExtranjeraModalComponent } from './components/formulario-no-experto/secciones/modales/patrimonio/patrimonio-deudas-extranjera-modal/patrimonio-deudas-extranjera-modal.component';
import { RentaCapitalModalComponent } from './components/formulario-no-experto/secciones/modales/renta-capital/renta-capital/renta-capital-modal.component';
import { RentasLaboralAsalariadoModalComponent } from './components/formulario-no-experto/secciones/modales/renta-laboral/renta-laboral-asalariado/renta-laboral-asalariado-modal.component';
import { RentaLaboralPrestacionServiciosModalComponent } from './components/formulario-no-experto/secciones/modales/renta-laboral/renta-laboral-prestacion-servicios-modal/renta-laboral-prestacion-servicios-modal.component';
import { RentaLaboralTecnicasModalComponent } from './components/formulario-no-experto/secciones/modales/renta-laboral/renta-laboral-tecnicas-modal/renta-laboral-tecnicas-modal.component';
import { RentaDividendosNacionalModalComponent } from './components/formulario-no-experto/secciones/modales/renta-dividendos/renta-dividendos-nacional-modal/renta-dividendos-nacional-modal.component';
import { RentaDividendosExteriorModalComponent } from './components/formulario-no-experto/secciones/modales/renta-dividendos/renta-dividendos-exterior-modal/renta-dividendos-exterior-modal.component';
import { RentaPensionesPensionadoModalComponent } from './components/formulario-no-experto/secciones/modales/renta-pensiones/renta-pensiones-pensionado-modal/renta-pensiones-pensionado-modal.component';
import { RentaPensionesSobrevivienteExteriorModalComponent } from './components/formulario-no-experto/secciones/modales/renta-pensiones/renta-pensiones-sobreviviente-modal/renta-pensiones-sobreviviente-modal.component';
import { RentaPensionesIndemnizacionDisponibleModalComponent } from './components/formulario-no-experto/secciones/modales/renta-pensiones/renta-pensiones-indemnizacion-modal/renta-pensiones-indemnizacion-modal.component';
import { RentaPensionesExteriorModalComponent } from './components/formulario-no-experto/secciones/modales/renta-pensiones/renta-pensiones-exterior-modal/renta-pensiones-exterior-modal.component';
import { DescuentosPerdidasModalComponent } from './components/formulario-no-experto/secciones/modales/descuentos/descuentos-perdidas-modal/descuentos-perdidas-modal.component';
import { DescuentosExcesosModalComponent } from './components/formulario-no-experto/secciones/modales/descuentos/descuentos-excesos-modal/descuentos-excesos-modal.component';
import { DescuentosLiquidasModalComponent } from './components/formulario-no-experto/secciones/modales/descuentos/descuentos-liquidas-modal/descuentos-liquidas-modal.component';
import { DescuentosPagosICAModalComponent } from './components/formulario-no-experto/secciones/modales/descuentos/descuentos-pagos-ica-modal/descuentos-pagos-ica-modal.component';
import { DescuentosDonacionesModalComponent } from './components/formulario-no-experto/secciones/modales/descuentos/descuentos-donaciones-moda/descuentos-donaciones-modal.component';
import { DescuentosAFProductivosModalComponent } from './components/formulario-no-experto/secciones/modales/descuentos/descuentos-af-productivos-modal/descuentos-af-productivos-modal.component';
import { DescuentosRentaAnteriorModalComponent } from './components/formulario-no-experto/secciones/modales/descuentos/descuentos-renta-anterior-modal/descuentos-renta-anterior-modal.component';
import { DescuentosRetencionModalComponent } from './components/formulario-no-experto/secciones/modales/descuentos/descuentos-retencion-modal/descuentos-retencion-modal.component';
import { DescuentosSancionModalComponent } from './components/formulario-no-experto/secciones/modales/descuentos/descuentos-sancion-modal/descuentos-sancion-modal.component';
import { DescuentosSancionExtemporaneaModalComponent } from './components/formulario-no-experto/secciones/modales/descuentos/descuentos-sancion-extemporanea-modal/descuentos-sancion-extemporanea-modal.component';
import { GananciasOcasionalesCasaModalComponent } from './components/formulario-no-experto/secciones/modales/ganancias-ocasionales/ganancias-ocasionales-casa-modal/ganancias-ocasionales-casa-modal.component';
import { GananciasOcasionalesInmueblesModalComponent } from './components/formulario-no-experto/secciones/modales/ganancias-ocasionales/ganancias-ocasionales-inmuebles-modal/ganancias-ocasionales-inmuebles-modal.component';
import { GananciasOcasionalesAccionesModalComponent } from './components/formulario-no-experto/secciones/modales/ganancias-ocasionales/ganancias-ocasionales-acciones-modal/ganancias-ocasionales-acciones-modal.component';
import { GananciasOcasionalesActivosModalComponent } from './components/formulario-no-experto/secciones/modales/ganancias-ocasionales/ganancias-ocasionales-activos-modal/ganancias-ocasionales-activos-modal.component';
import { GananciasOcasionalesHerenciaModalComponent } from './components/formulario-no-experto/secciones/modales/ganancias-ocasionales/ganancias-ocasionales-herencia-modal/ganancias-ocasionales-herencia-modal.component';
import { GananciasOcasionalesIndemnizacionModalComponent } from './components/formulario-no-experto/secciones/modales/ganancias-ocasionales/ganancias-ocasionales-indemnizacion-modal/ganancias-ocasionales-indemnizacion-modal.component';
import { GananciasOcasionalesPremiosModalComponent } from './components/formulario-no-experto/secciones/modales/ganancias-ocasionales/ganancias-ocasionales-premios-modal/ganancias-ocasionales-premios-modal.component';
import { GananciasOcasionalesPremiosExteriorModalComponent } from './components/formulario-no-experto/secciones/modales/ganancias-ocasionales/ganancias-ocasionales-premios-exterior-modal/ganancias-ocasionales-premios-exterior-modal.component';
import { GananciasOcasionalesPremiosHipicosModalComponent } from './components/formulario-no-experto/secciones/modales/ganancias-ocasionales/ganancias-ocasionales-premios-hipicos-modal/ganancias-ocasionales-premios-hipicos-modal.component';
import { GananciasOcasionalesPremiosTitulosModalComponent } from './components/formulario-no-experto/secciones/modales/ganancias-ocasionales/ganancias-ocasionales-premios-titulos-modal/ganancias-ocasionales-premios-titulos-modal.component';
import { GananciasOcasionalesConcursoNacionalModalComponent } from './components/formulario-no-experto/secciones/modales/ganancias-ocasionales/ganancias-ocasionales-concurso-nacional-modal/ganancias-ocasionales-concurso-nacional-modal.component';
import { GananciasOcasionalesConcursoExteriorModalComponent } from './components/formulario-no-experto/secciones/modales/ganancias-ocasionales/ganancias-ocasionales-concurso-exterior-modal/ganancias-ocasionales-concurso-exterior-modal.component';
import { GananciasOcasionalesLiquidacionModalComponent } from './components/formulario-no-experto/secciones/modales/ganancias-ocasionales/ganancias-ocasionales-liquidacion-exterior-modal/ganancias-ocasionales-liquidacion-modal.component';
import { GananciasOcasionalesOtrosIngresosModalComponent } from './components/formulario-no-experto/secciones/modales/ganancias-ocasionales/ganancias-ocasionales-otros-ingresos-modal/ganancias-ocasionales-otros-ingresos-modal.component';
import { TableItemsComponent } from './components/table-items/table-items.component';
import { InitContainerComponent } from './components/init-container/init-container.component';
import { QuestionComponent } from './components/question/question.component';
import { RentaNoLaboralComponent } from './components/formulario-no-experto/secciones/renta-no-laboral/renta-no-laboral.component';
import { RentaNoLaboralComercianteModalComponent } from './components/formulario-no-experto/secciones/modales/renta-no-laboral/renta-no-laboral-comerciante-modal/renta-no-laboral-comerciante-modal.component';
import { RentaNoLaboralInmueblesModalComponent } from './components/formulario-no-experto/secciones/modales/renta-no-laboral/renta-no-laboral-inmuebles-modal/renta-no-laboral-inmuebles-modal.component';
import { RentaNoLaboralAccionesModalComponent } from './components/formulario-no-experto/secciones/modales/renta-no-laboral/renta-no-laboral-acciones-modal/renta-no-laboral-acciones-modal.component';
import { RentaNoLaboralActivosModalComponent } from './components/formulario-no-experto/secciones/modales/renta-no-laboral/renta-no-laboral-activos-modal/renta-no-laboral-activos-modal.component';
import { RentaNoLaboralUtilidadesLiquidacionModalComponent } from './components/formulario-no-experto/secciones/modales/renta-no-laboral/renta-no-laboral-utilidades-liquidacion-modal/renta-no-laboral-utilidades-liquidacion-modal.component';
import { RentaNoLaboralEximidosDeudasModalComponent } from './components/formulario-no-experto/secciones/modales/renta-no-laboral/renta-no-laboral-eximidos-deudas-modal/renta-no-laboral-eximidos-deudas-modal.component';
import { RentaNoLaboralRecompensasModalComponent } from './components/formulario-no-experto/secciones/modales/renta-no-laboral/renta-no-laboral-recompensas-modal/renta-no-laboral-recompensas-modal.component';
import { RentaNoLaboralHoteleraModalComponent } from './components/formulario-no-experto/secciones/modales/renta-no-laboral/renta-no-laboral-hotelera-modal/renta-no-laboral-hotelera-modal.component';
import { RentaNoLaboralOtrosIngresosModalComponent } from './components/formulario-no-experto/secciones/modales/renta-no-laboral/renta-no-laboral-otros-ingresos-modal/renta-no-laboral-otros-ingresos-modal.component';
import { RentaNoLaboralIndemnizacionesModalComponent } from './components/formulario-no-experto/secciones/modales/renta-no-laboral/renta-no-laboral-indemnizaciones-modal/renta-no-laboral-indemnizaciones-modal.component';
import { RentaNoLaboralIngresosAnterioresModalComponent } from './components/formulario-no-experto/secciones/modales/renta-no-laboral/renta-no-laboral-ingresos-anteriores-modal/renta-no-laboral-ingresos-anteriores-modal.component';
import { RentaNoLaboralEximidosPrestamosModalComponent } from './components/formulario-no-experto/secciones/modales/renta-no-laboral/renta-no-laboral-eximidos-prestamos-modal/renta-no-laboral-eximidos-prestamos-modal.component';
import { DescuentosRentaPresuntivaModalComponent } from './components/formulario-no-experto/secciones/modales/descuentos/descuentos-renta-presuntiva-modal/descuentos-renta-presuntiva-modal.component';
import { DescuentosSaldoAFavorModalComponent } from './components/formulario-no-experto/secciones/modales/descuentos/descuentos-saldo-a-favor/descuentos-saldo-a-favor-modal';
import { MatIconModule, MatSelectModule } from '@angular/material';
import { DialogoSiNoComponent } from './components/table-items/dialogo-si-no/dialogo-si-no.component';
import { MisDeudasComponent } from './components/formulario-no-experto/secciones/mis-deudas/mis-deudas.component';
import { MisIngresosComponent } from './components/formulario-no-experto/secciones/mis-ingresos/mis-ingresos.component';
import { MisBeneficiosTributariosComponent } from './components/formulario-no-experto/secciones/mis-beneficios-tributarios/mis-beneficios-tributarios.component';
import { MiImpuestoDeRentaComponent } from './components/formulario-no-experto/secciones/mi-impuesto-de-renta/mi-impuesto-de-renta.component';
import { DialogoConfirmacionComponent } from './components/table-items/dialogo-confirmacion/dialogo-confirmacion.component';
import { IngresosRetiroAFCOTROSModalComponent } from './components/formulario-no-experto/secciones/modales/ingresos/ingresos-modal-retiro-AFC-OTROS/ingresos-retiro-modal-AFC-OTROS.component';

import { PatrimonioActivosOmitidosModalComponent } from './components/formulario-no-experto/secciones/modales/patrimonio/patrimonio-activos-omitidos-modal/patrimonio-activos-omitidos-modal.component';
import { PatrimonioOtrosActivosModalComponent } from './components/formulario-no-experto/secciones/modales/patrimonio/patrimonio-otros-activos-modal/patrimonio-otros-activos-modal.component';
import { PatrimonioDeudasAntModalComponent } from './components/formulario-no-experto/secciones/modales/patrimonio/patrimonio-deudas-anteriores-modal/patrimonio-deudas-anteriores-modal.component';
import { IngresosArrendamientosModalComponent } from './components/formulario-no-experto/secciones/modales/ingresos/ingresos-arrendamientos/ingresos-arrendamientos-modal.component';
import { IngresoHerenciaDonaConyugalModalComponent } from './components/formulario-no-experto/secciones/modales/ingresos/ingresos-herencia-donacion-conyugal-modal/ingresos-herencia-dona-conyugal-modal.component';
import { IngresosAsalariadooServidorpublicoModalComponent } from './components/formulario-no-experto/secciones/modales/ingresos/ingresos-asalariado-o-servidor-publico-modal/ingresos-asalariado-o-servidor-publico-modal.component';
import { IngresostrabajadorindependienteModalComponent } from './components/formulario-no-experto/secciones/modales/ingresos/ingresos-trabajador-independiente-modal/ingresos-trabajador-independiente-modal.component';
import { IngresosComercianteModalComponent } from './components/formulario-no-experto/secciones/modales/ingresos/ingresos-comerciante/ingresos-comerciante-modal.component';
import { IngresosOtrosIngresosModalComponent } from './components/formulario-no-experto/secciones/modales/ingresos/ingresos-otros-ingresos-modal/ingresos-otros-ingresos-modal.component';
import { IngresosVentaViviendaModalComponent } from './components/formulario-no-experto/secciones/modales/ingresos/ingresos-venta-vivienda-modal/ingresos-venta-vivienda-modal.component';
import { IngresosPensionesModalComponent } from './components/formulario-no-experto/secciones/modales/ingresos/ingresos-pensiones/ingresos-pensiones-modal.component';
import { IngresosDividendosOParticipacionesModalComponent } from './components/formulario-no-experto/secciones/modales/ingresos/ingresos-dividendos-participaciones-modal/ingresos-dividendos-participaciones-modal.component';
import { IngresosVentaActivosFijosModalComponent } from './components/formulario-no-experto/secciones/modales/ingresos/ingresos-venta-activos-fijos-modal/ingresos-venta-activos-fijos-modal.component';
import { IngresosRentasPasivasECEModalComponent } from './components/formulario-no-experto/secciones/modales/ingresos/ingresos-rentas-pasivas-ECE-modal/ingresos-rentas-pasivas-ECE-modal.component';
import { IngresosLoteriasPremiosRifasApuestasSimilaresModalComponent } from './components/formulario-no-experto/secciones/modales/ingresos/ingresos-loterias-premios-rifas-apuestas-similares-modal/ingresos-loterias-premios-rifas-apuestas-similares-modal.component';
import { BeneficiosTributariosDeduccionesEspecialesModalComponent } from './components/formulario-no-experto/secciones/modales/beneficios-tributarios/beneficios-tributarios-deducciones-especiales/beneficios-tributarios-deducciones-especiales-modal.component';
import { BeneficiosDependientesModalComponent } from './components/formulario-no-experto/secciones/modales/beneficios-tributarios/beneficios-dependientes-modal/beneficios-dependientes-modal.component';
import { IngresosUtilidadesLiquidacionModal } from './components/formulario-no-experto/secciones/modales/ingresos/ingresos-utilidades-liquidacion-modal/ingresos-utilidades-liquidacion-modal.component';
import { ImpuestoRentaSaldoaFavorDeclaracionAñoAnteriorModalComponent } from './components/formulario-no-experto/secciones/modales/impuesto-renta/impto-renta-saldo-a-favor-ano-anterior-modal/impto-renta-saldo-a-favor-ano-anterior-modal.component';
import { BeneficiosIngresosNoGravados } from './components/formulario-no-experto/secciones/modales/beneficios-tributarios/beneficios-ingresos-no-gravados-modal/beneficios-ingresos-no-gravados-modal.component';
import { SugeridaSingletonService } from './services/sugerida.service';
import { BeneficiosTributariosDescuentosModalComponent } from './components/formulario-no-experto/secciones/modales/beneficios-tributarios/beneficios-tributarios-descuentos/beneficios-tributarios-descuentos-modal.component';
import { BeneficiosComprasFacturaElectronicaModalComponent } from './components/formulario-no-experto/secciones/modales/beneficios-tributarios/beneficios-compras-factura-electronica/beneficios-compras-factura-electronica-modal.component';
import { BeneficiosRentasExentasSinLimiteModalComponent } from './components/formulario-no-experto/secciones/modales/beneficios-tributarios/beneficios-rentas-exentas-sin-limite-modal/beneficios-rentas-exentas-sin-limite-modal.component';
import { ImpuestoRentaTuvoCostosyGastosaDeducirModalComponent } from './components/formulario-no-experto/secciones/modales/impuesto-renta/impto-renta-costos-y-gastos-para-deducir-modal/impto-renta-costos-y-gastos-para-deducir-modal.component';
import { BeneficiosRentasExentasDeImpuestoModalComponent } from './components/formulario-no-experto/secciones/modales/beneficios-tributarios/beneficios-rentas-exentas-de-impuesto/beneficios-rentas-exentas-de-impuesto-modal.component';
import { CompensacionModalComponent } from './components/formulario-no-experto/secciones/modales/impuesto-renta/compensacion-modal/compensacion-modal.component';
import { RentasLiquidasGravablesComponent } from './components/formulario-no-experto/secciones/modales/impuesto-renta/rentas-liquidas-gravables-modal/rentas-liquidas-gravables-modal.component';
import { AnticiposComponent } from './components/formulario-no-experto/secciones/modales/impuesto-renta/anticipos-modal/anticipos-modal.component';
import { SancionComponent } from './components/formulario-no-experto/secciones/modales/impuesto-renta/sancion-modal/sancion-modal.component';
import { DevolucionesComponent } from './components/devoluciones/devoluciones.component';
import { DSeleccionarTextoInput } from './directives/dseleccionar-texto-input';

@NgModule({
  declarations: [
    AppComponent,
    PieComponent,
    InitContainerComponent,
    CabeceraFormularioComponent,
    ContenedorFormularioComponent,
    FormularioComponent,
    ContenedorFormularioNoExpertoComponent,
    FormularioNoExpertoComponent,
    DNotificacionesComponente,
    DSpeedDialComponente,
    DFirmaComponente,
    DEnvioLogComponente,
    DPreguntasComponente,
    FormateoValorPipe,
    FormatoMonedaDirectiva,
    DRenderizarPorParametrosDirectiva,
    DMostrarAyudaDirectiva,
    // DialogoDeclaSugeridaComponent,
    // DialogoFacturaRentaComponent,
    // DialogoValoresDeclaracionSugeridaComponent,
    // DialogoFacturaEjecutoriaComponent,
    // DialogoConsultaDeclaracionSugeridaComponent,
    // DialogoValoresFacturaRentaComponent,
    // DialogoConsultaFacturaRentaComponent,    
    DMostrarAyudaBaseComponent,
    DSoloNumeros,
    LoadingComponent,
    TabComponent,
    StepperComponent,
    GeneralDialogComponent,
    TooltipDirective,
    ItemMenuComponent,
    SugeridaComponent,
    TitleModalComponent,
    //====== No expertos
    HeaderCardNoExpertosComponent,
    IndicatorComponent,
    TableItemsComponent,

    QuestionComponent,
    //Modales
    CompensacionModalComponent,
    RentasLiquidasGravablesComponent,
    AnticiposComponent,
    SancionComponent,
    PatrimonioMueblesModalComponent,
    PatrimonioInmueblesModalComponent,
    PatrimonioAccionesModalComponent,
    PatrimonioDisponibleModalComponent,
    PatrimonioInventarioModalComponent,
    RentasLaboralAsalariadoModalComponent,
    RentaLaboralPrestacionServiciosModalComponent,
    RentaLaboralTecnicasModalComponent,
    PatrimonioOtrosActivosModalComponent,
    PatrimonioActivosOmitidosModalComponent,
    PatrimonioActivosExtranjeraModalComponent,
    PatrimonioDeudaNacionalModalComponent,
    PatrimonioDeudasExtranjeraModalComponent,
    RentaCapitalModalComponent,
    RentaDividendosNacionalModalComponent,
    RentaDividendosExteriorModalComponent,
    RentaPensionesPensionadoModalComponent,
    RentaPensionesSobrevivienteExteriorModalComponent,
    RentaPensionesIndemnizacionDisponibleModalComponent,
    RentaPensionesExteriorModalComponent,
    DescuentosPerdidasModalComponent,
    DescuentosRentaPresuntivaModalComponent,
    DescuentosExcesosModalComponent,
    DescuentosLiquidasModalComponent,
    DescuentosPagosICAModalComponent,
    DescuentosDonacionesModalComponent,
    DescuentosAFProductivosModalComponent,
    DescuentosRentaAnteriorModalComponent,
    DescuentosRetencionModalComponent,
    DescuentosSaldoAFavorModalComponent,
    DescuentosSancionModalComponent,
    DescuentosSancionExtemporaneaModalComponent,
    GananciasOcasionalesCasaModalComponent,
    GananciasOcasionalesInmueblesModalComponent,
    GananciasOcasionalesAccionesModalComponent,
    GananciasOcasionalesActivosModalComponent,
    GananciasOcasionalesHerenciaModalComponent,
    GananciasOcasionalesIndemnizacionModalComponent,
    GananciasOcasionalesPremiosModalComponent,
    GananciasOcasionalesPremiosExteriorModalComponent,
    GananciasOcasionalesPremiosHipicosModalComponent,
    GananciasOcasionalesPremiosTitulosModalComponent,
    GananciasOcasionalesConcursoNacionalModalComponent,
    GananciasOcasionalesConcursoExteriorModalComponent,
    GananciasOcasionalesLiquidacionModalComponent,
    GananciasOcasionalesOtrosIngresosModalComponent,
    RentaNoLaboralComercianteModalComponent,
    RentaNoLaboralInmueblesModalComponent,
    RentaNoLaboralAccionesModalComponent,
    RentaNoLaboralActivosModalComponent,
    RentaNoLaboralUtilidadesLiquidacionModalComponent,
    RentaNoLaboralEximidosPrestamosModalComponent,
    RentaNoLaboralEximidosDeudasModalComponent,
    RentaNoLaboralRecompensasModalComponent,
    RentaNoLaboralOtrosIngresosModalComponent,
    RentaNoLaboralHoteleraModalComponent,
    RentaNoLaboralIndemnizacionesModalComponent,
    RentaNoLaboralIngresosAnterioresModalComponent,
    //Componentes secciones para no expertos
    DatosDeclaranteComponent,
    PatrimonioComponent,
    //nuevos v18 no experto
    MisDeudasComponent,
    MisIngresosComponent,
    MisBeneficiosTributariosComponent,
    MiImpuestoDeRentaComponent,
    //nuevos v18 no experto

    RentaCapitalComponent,
    RentaLaboralComponent,
    RentaDividendosComponent,
    RentaPensionesComponent,
    GananciasOcasionalesComponent,
    DescuentosComponent,
    RentaNoLaboralComponent,
    DialogoSiNoComponent,
    DialogoConfirmacionComponent,
    IngresosRetiroAFCOTROSModalComponent,
    IngresosArrendamientosModalComponent,
    IngresosComercianteModalComponent,
    IngresosPensionesModalComponent,
    PatrimonioDeudasAntModalComponent,
    IngresoHerenciaDonaConyugalModalComponent,
    IngresosAsalariadooServidorpublicoModalComponent,
    IngresostrabajadorindependienteModalComponent,
    IngresosVentaViviendaModalComponent,
    IngresosVentaActivosFijosModalComponent,
    IngresosUtilidadesLiquidacionModal,
    IngresosDividendosOParticipacionesModalComponent,
    IngresosOtrosIngresosModalComponent,
    IngresosRentasPasivasECEModalComponent,
    IngresosLoteriasPremiosRifasApuestasSimilaresModalComponent,
    BeneficiosTributariosDeduccionesEspecialesModalComponent,
    BeneficiosTributariosDescuentosModalComponent,
    MisBeneficiosTributariosComponent,
    BeneficiosDependientesModalComponent,
    ImpuestoRentaSaldoaFavorDeclaracionAñoAnteriorModalComponent,
    BeneficiosIngresosNoGravados,
    BeneficiosComprasFacturaElectronicaModalComponent,
    BeneficiosRentasExentasSinLimiteModalComponent,
    ImpuestoRentaTuvoCostosyGastosaDeducirModalComponent,
    BeneficiosRentasExentasDeImpuestoModalComponent,
    DSeleccionarTextoInput,
    //===== End no expertos


    //Devoluciones
    DevolucionesComponent
  ],
  imports: [
    MatSelectModule,
    MatIconModule,
    //Angular
    BrowserModule,
    HttpModule,
    FormsModule,
    BrowserAnimationsModule,
    NoopAnimationsModule,
    //External
    Ng2Webstorage.forRoot({
      prefix: 'DIAN',
      separator: '-',
      caseSensitive: true
    }),
    //Traductor
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderTranslatorFactory,
        deps: [HttpClient]
      },
      missingTranslationHandler: {
        provide: MissingTranslationHandler,
        useClass: MissingTranslationHandlerDIAN
      }
    }),
    //Material
    FlexLayoutModule,
    MaterialModule,
    DatepickerModule,
    DateValueAccessorModule,
    DReciboPagoModule,
    //DReciboPagoExteriorModule,
    //Aplicacion
    AppRoutingModule
  ],
  exports: [
    TranslateModule,
    DialogoSiNoComponent
  ],
  providers: [
    SugeridaSingletonService,
    MessageObservableService,
    CookieService,
    Compiler,
    Logger,
    DNotificacionServicio, //Viejo del framework
    NotificationsService, //Nuevo
    DMessageObsService,
    {
      provide: DLogger,
      useFactory: loggerFactory,
      deps: [Logger, SessionStorageService]
    },
    {
      provide: DSessionStorage,
      useFactory: sessionStorageFactory,
      deps: [SessionStorageService, DLogger]
    },
    {
      provide: DContextoMuiscaServicio,
      useFactory: contextoMuiscaFactory,
      deps: [Http, CookieService, Compiler, DLogger, DNotificacionServicio, DSessionStorage, DFormularioConfiguracion, DMessageObsService]
    },
    {
      provide: DFormularioServicio,
      useFactory: formularioFactory,
      deps: [DContextoMuiscaServicio]
    },
    {
      provide: DValidacionesFormularioServicio,
      useFactory: validacionesFormularioFactory,
      deps: [DFormularioConfiguracion, DOperacionesMatematicasServicio]
    },
    {
      provide: DAyudasFormularioServicio,
      useFactory: ayudasFormularioFactory,
      deps: [DAyudasFormulario]
    },
    FormateoValorPipe,
    DOperacionesMatematicasServicio,
    DFormularioConfiguracion,
    DAyudasFormulario
  ],
  bootstrap: [
    AppComponent
  ],
  entryComponents: [    
    DialogoSiNoComponent,
    DialogoConfirmacionComponent,
    DNotificacionesComponente,
    DEnvioLogComponente,
    DFirmaComponente,
    DPreguntasComponente,
    // DialogoDeclaSugeridaComponent,
    // DialogoFacturaRentaComponent,
    // DialogoValoresDeclaracionSugeridaComponent,
    // DialogoFacturaEjecutoriaComponent,
    // DialogoValoresFacturaRentaComponent,
    // DialogoConsultaFacturaRentaComponent,
    // DialogoConsultaDeclaracionSugeridaComponent,
    LoadingComponent,
    GeneralDialogComponent,
    SugeridaComponent,
    //Modales no expertos
    CompensacionModalComponent,
    RentasLiquidasGravablesComponent,
    AnticiposComponent,
    SancionComponent,
    PatrimonioMueblesModalComponent,
    PatrimonioInmueblesModalComponent,
    PatrimonioAccionesModalComponent,
    PatrimonioDisponibleModalComponent,
    PatrimonioInventarioModalComponent,
    PatrimonioOtrosActivosModalComponent,
    PatrimonioActivosOmitidosModalComponent,
    PatrimonioActivosExtranjeraModalComponent,
    PatrimonioDeudaNacionalModalComponent,
    PatrimonioDeudasExtranjeraModalComponent,
    RentaCapitalModalComponent,
    RentasLaboralAsalariadoModalComponent,
    RentaLaboralPrestacionServiciosModalComponent,
    RentaLaboralTecnicasModalComponent,
    RentaDividendosNacionalModalComponent,
    RentaDividendosExteriorModalComponent,
    RentaPensionesPensionadoModalComponent,
    RentaPensionesSobrevivienteExteriorModalComponent,
    RentaPensionesIndemnizacionDisponibleModalComponent,
    RentaPensionesExteriorModalComponent,
    DescuentosPerdidasModalComponent,
    DescuentosRentaPresuntivaModalComponent,
    DescuentosExcesosModalComponent,
    DescuentosLiquidasModalComponent,
    DescuentosPagosICAModalComponent,
    DescuentosDonacionesModalComponent,
    DescuentosAFProductivosModalComponent,
    DescuentosRentaAnteriorModalComponent,
    DescuentosRetencionModalComponent,
    DescuentosSaldoAFavorModalComponent,
    DescuentosSancionModalComponent,
    DescuentosSancionExtemporaneaModalComponent,
    GananciasOcasionalesCasaModalComponent,
    GananciasOcasionalesInmueblesModalComponent,
    GananciasOcasionalesAccionesModalComponent,
    GananciasOcasionalesActivosModalComponent,
    GananciasOcasionalesHerenciaModalComponent,
    GananciasOcasionalesIndemnizacionModalComponent,
    GananciasOcasionalesPremiosModalComponent,
    GananciasOcasionalesPremiosExteriorModalComponent,
    GananciasOcasionalesPremiosHipicosModalComponent,
    GananciasOcasionalesPremiosTitulosModalComponent,
    GananciasOcasionalesConcursoNacionalModalComponent,
    GananciasOcasionalesConcursoExteriorModalComponent,
    GananciasOcasionalesLiquidacionModalComponent,
    GananciasOcasionalesOtrosIngresosModalComponent,
    RentaNoLaboralComercianteModalComponent,
    RentaNoLaboralInmueblesModalComponent,
    RentaNoLaboralAccionesModalComponent,
    RentaNoLaboralActivosModalComponent,
    RentaNoLaboralUtilidadesLiquidacionModalComponent,
    RentaNoLaboralEximidosPrestamosModalComponent,
    RentaNoLaboralEximidosDeudasModalComponent,
    RentaNoLaboralRecompensasModalComponent,
    RentaNoLaboralOtrosIngresosModalComponent,
    RentaNoLaboralHoteleraModalComponent,
    RentaNoLaboralIndemnizacionesModalComponent,
    RentaNoLaboralIngresosAnterioresModalComponent,
    IngresosRetiroAFCOTROSModalComponent,
    IngresosArrendamientosModalComponent, 
    IngresosVentaViviendaModalComponent,   
    IngresosVentaActivosFijosModalComponent,
    IngresosDividendosOParticipacionesModalComponent,
    IngresosComercianteModalComponent,
    IngresosPensionesModalComponent,
    IngresosOtrosIngresosModalComponent,
    PatrimonioDeudasAntModalComponent,
    IngresoHerenciaDonaConyugalModalComponent,
    IngresosAsalariadooServidorpublicoModalComponent,
    IngresostrabajadorindependienteModalComponent,
    IngresosRentasPasivasECEModalComponent,
    IngresosLoteriasPremiosRifasApuestasSimilaresModalComponent,
    IngresosUtilidadesLiquidacionModal,
    BeneficiosTributariosDeduccionesEspecialesModalComponent,
    BeneficiosTributariosDescuentosModalComponent,
    BeneficiosDependientesModalComponent,
    ImpuestoRentaSaldoaFavorDeclaracionAñoAnteriorModalComponent,
    BeneficiosIngresosNoGravados,
    BeneficiosComprasFacturaElectronicaModalComponent,
    BeneficiosRentasExentasSinLimiteModalComponent,
    ImpuestoRentaTuvoCostosyGastosaDeducirModalComponent,
    BeneficiosRentasExentasDeImpuestoModalComponent,

    //Devoluciones
    DevolucionesComponent
  ]
})
export class AppModule { }





// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/app.module.ts